<template lang="pug">
  v-card(flat)
    v-window(v-model="window")
      v-window-item
        server-data(
          ref="lsit"
          :method="fetch"
          :query="query"
          v-slot="{ serverData, loading }"
        )
          data-wrapper(
            :loading="loading"
            :skeleton-items-count="4"
            :has-items="!!serverData.length"
            skeleton-type="paragraph"
            :colsProps="{ cols: 12, md: 12, sm: 12, xl: 12 }"
          )
            template(#no-data)
              v-alert(
                type="info" prominent text
              ).mx-auto Нет сформированных счетов
            template(#default)
              v-list
                v-list-item-group(
                  v-model="selected"
                )
                  v-list-item(
                    v-for="item in serverData"
                    :key="item.id"
                    :disabled="item.is_paid"
                    :value="item"
                  )
                    template(v-slot:default="{ active }")
                      v-list-item-content
                        .text-body-2: strong № {{ item.number }}
                          span.ml-2.caption.success--text(v-if="item.is_paid") Подтвержден
                        .caption На сумму: {{ item.sum / 100 }} ₽ {{item.test}}
                      v-list-item-action.mr-4(
                        v-if="!item.is_paid"
                      ): v-checkbox( :input-value="active")
        v-btn(
          color="primary" block
          :disabled="!selected"
          :loading="loading"
          @click="success(selected.sum)"
        ) Подтвердить
        v-btn.mt-2(
          text small block color="primary"
          @click="window = 1"
        ) {{ !selected ? 'Внести сумму без счета' : 'Уточнить сумму'}}

      v-window-item
        .d-flex.align-center.mb-2
          .text-body-2.ml-4.mb-4(
            v-if="!selected"
          ) Уточнение суммы оплаты по контракту
          .text-body-2.ml-4.mb-4(
            v-else
          ) Уточнение суммы оплаты по Счету № {{ selected.number }}
          v-btn.ml-auto.mb-2(
            text small color="primary"
            @click="window = 0"
          )
            v-icon(left) mdi-arrow-left
            span Назад

        v-text-field(
          v-model="extendSum"
          rounded filled
          type="number"
          label="Введите сумму оплаты"
        )
        v-btn.ml-auto(
          color="primary" block
          :disabled="!extendSum"
          :loading="contract.paymentLoading"
          @click="success(extendSum)"
        ) Подтвердить

</template>
<script>
import PaymentInvoice from '@/models/list/PaymentInvoice';

export default {
  props: {
    contract: { type: Object, required: true },
  },
  data() {
    return {
      query: {
        'search[contract_id]': this.contract.id,
      },
      window: 0,
      selected: null,
      extendSum: null,
      loading: false,
    };
  },
  methods: {
    async success(extendSum) {
      this.loading = true;
      const data = {
        is_paid: 1,
        ...extendSum ? { sum: extendSum } : {},
      };
      if (this.selected) {
        const res = await this.selected.update({ data });
        this.setPayment(Number(res.data.data.sum / 100).toFixed(2));
      } else {
        this.setPayment(extendSum * 100);
      }
      this.$modals.close();
    },
    setPayment(sum) {
      this.contract.setPayment(Number(sum));
      this.loading = false;
    },
    fetch(data) {
      return this.$api.paymentInvoice.index(
        data,
        { model: PaymentInvoice, many: true },
      );
    },
  },
};
</script>
